export enum UserRole {
  User = 'USER',
  Admin = 'ADMIN',
  Test = 'TEST'
}
